import React from 'react';
import styles from './DirectorInformations.module.sass';
import Card from '../../../components/Card';
import TextInput from '../../../components/TextInput';
import PhoneInput from '../../../components/PhoneInput';

const DirectorInformations = ({ center, onCenterChange }) => {
    return (
        <Card className={styles.card} title="Informations du directeur" classTitle="title-green">
            <div className={styles.group}>
                <TextInput
                    className={styles.field}
                    label="Nom du directeur"
                    name="director_last_name"
                    type="text"
                    placeholder="Nom du directeur"
                    value={center?.director_last_name || ''}
                    onChange={onCenterChange}
                    required
                />
                <TextInput
                    className={styles.field}
                    label="Prénom du directeur"
                    name="director_first_name"
                    type="text"
                    placeholder="Prénom du directeur"
                    value={center?.director_first_name || ''}
                    onChange={onCenterChange}
                />
                <PhoneInput
                    className={styles.field}
                    label="Numéro de téléphone du directeur"
                    name="director_phone"
                    id="director_phone"
                    placeholder="+33 6 XX XX XX XX"
                    value={center?.director_phone || ''}
                    onChange={onCenterChange}
                    autoComplete="tel"
                />
                <TextInput
                    className={styles.field}
                    label="Email du directeur"
                    name="director_email"
                    type="email"
                    placeholder="email@example.com"
                    value={center?.director_email || ''}
                    onChange={onCenterChange}
                    required
                />
            </div>
        </Card>
    );
};

export default DirectorInformations;